import {GetArrayFromRecursive, GetFlatArrayFromRecursive, normalizeItems} from '../../helpers/Helpers';

const initialState = {
    flat: [],
    items: [],
    filtered: [],
    select: [],
    menu: [],
    single: {},
    parentWorkspaceId: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'CONTENT_RESET':
            return initialState;

        case 'CONTENT_FILTER':
            return {
                ...state,
                filtered: action.payload.data
            };
            
        case 'GET_GLOBALS_FOR_WORKSPACE':
            return {
                ...state,
                items: action.payload.structure,
                filtered: action.payload.structure,
                menu: normalizeItems(action.payload.structure),
                flat: GetFlatArrayFromRecursive(action.payload.structure),
                select: GetArrayFromRecursive(action.payload.structure),
                parentWorkspaceId: action.payload.parentWorkspaceId
            };
            
        case 'CONTENT_SINGLE_SUCCESS':
            return {
                ...state,
                single: action.payload.data
            };
            
        case 'CONTENT_STRUCTURE_SUCCESS':
            if (action.payload.skipStore === false) {
                return {
                    ...state,
                    items: action.payload.data,
                    filtered:  action.payload.data,
                    menu: normalizeItems(action.payload.data),
                    flat: GetFlatArrayFromRecursive(action.payload.data),
                    select: GetArrayFromRecursive(action.payload.data),
                    parentWorkspaceId: action.payload.parentWorkspaceId
                };
            } else {
                return {
                    ...state
                }
            }
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/admin/store/reducers/content.js